import React, { FC } from 'react';
import { FieldArray, FieldArrayFieldsProps, FieldArrayMetaProps } from 'redux-form';
import { SpaPackageType } from 'shared-types/SpaPackage';
import { useTranslations } from '@lang';
import { filterTimeslotOptionsByStaffAndRoomAvailability } from '@routes/SpaDay/SpaPackageModal/SpaPackageAvailability/GuestDetailsAndSelections/TimeSlotFiltering/timeslotFiltering';
import { GuestFields } from './GuestFields';
import { ConfigurationGroup } from './ConfigurationGroup';
import { configurationGroupValidator } from './validators';
import { GroupError } from './GroupError';

type GuestDetailsProps = {
  fieldPrefix: string;
  guestIndex: number;
  entity: SpaPackageType;
  formChange: (...args: any[]) => any;
  fields: FieldArrayFieldsProps<any>;
  showGenderNeutral?: boolean;
  selected: {
    any: number;
  } | null;
  meta: FieldArrayMetaProps;
};

export const GuestDetails: FC<GuestDetailsProps> = ({
  entity,
  fieldPrefix,
  formChange,
  guestIndex,
  fields,
  showGenderNeutral,
  selected,
  meta,
}) => {
  const { t } = useTranslations();
  const { configurationGroups, configurationGroupsRequireTimeslots, supportsTimeslots } = entity;

  const configurationGroupsNoExtras = configurationGroups.filter((group) => !group.isExtras);

  const configurationGroupsSupportsSelections = configurationGroupsNoExtras.some(
    (group) => group.supportsSelections
  );

  const noArrivalTimesRequiresTimeslots = !supportsTimeslots && configurationGroupsRequireTimeslots;

  const requiresTimeslotsHasTimeslots =
    configurationGroupsRequireTimeslots &&
    configurationGroupsNoExtras.some((group) => group.supportsTimeslots);

  return (
    <>
      <GuestFields
        guestIndex={guestIndex}
        fieldPrefix={fieldPrefix}
        formChange={formChange}
        fields={fields}
        showGenderNeutral={showGenderNeutral}
      />
      <GroupError meta={meta} />
      {(configurationGroupsSupportsSelections ||
        noArrivalTimesRequiresTimeslots ||
        requiresTimeslotsHasTimeslots) &&
        configurationGroupsNoExtras
          .filter((cg) => cg.isRequired)
          .map(
            (
              {
                options,
                supportsSelections,
                minimumSelections,
                maximumSelections,
                id,
                supportsTimeslots,
              },
              index
            ) => {
              const filteredOptions = filterTimeslotOptionsByStaffAndRoomAvailability(
                options,
                selected,
                id,
                guestIndex
              );
              return (
                <FieldArray
                  key={id}
                  configurationGroupId={id}
                  component={ConfigurationGroup}
                  name={`${fieldPrefix}.configurationGroups.group_${id}` as string}
                  validate={configurationGroupValidator(t, minimumSelections)}
                  options={filteredOptions}
                  maximumSelections={maximumSelections}
                  minimumSelections={minimumSelections}
                  supportsSelections={supportsSelections}
                  requireTimeSlots={configurationGroupsRequireTimeslots}
                  index={index}
                  supportsTimeslots={supportsTimeslots}
                />
              );
            }
          )}
    </>
  );
};
